<div class="row">
  <div class="col-md-9">
    <h4>Add Accessories </h4>
  </div>
  <div class="col-md-3">
    <select class="form-control custom-input" (change)="onWarehouseSelect($event)">
      <option>Select Warehouse</option>
      <option *ngFor="let warehouse of warehousesMap[currentFragment]" [value]="warehouse.id" [selected]="this.selectedWarehouseId === warehouse.id">{{ warehouse.warehouse_name }} ({{ warehouse.code }})</option>
    </select>
  </div>
</div>
<br />
<div class="row">
  <div class="col-md-12">
    <div class="accessories-tab">
      <ul class="nav nav-tabs nav-justified search-nav-tabs self-tabs" id="myTab" role="tablist">
        <li class="nav-item" *ngFor="let cat of categories">
          <a class="nav-link" [class.active]="currentFragment === cat.slug" (click)="onTabChange(cat)"
            data-toggle="tab" role="tab" [attr.aria-controls]="cat.slug"
            [attr.aria-selected]="currentFragment === cat.slug">{{ cat.name }}</a>
        </li>
      </ul>
    </div>

    <div class="tab-content">
      <div *ngFor="let cat of categories" [class.active]="currentFragment === cat.slug"
        [class.show]="currentFragment === cat.slug" class="tab-pane fade" role="tabpanel"
        [attr.aria-labelledby]="cat.slug">
        <div class="table-responsive">
          <table class="table details-table">
            <tbody>
              <span *ngIf="addOns.length === 0">No Add Ons found</span>
              <tr *ngFor="let addOn of cat.addOns">
                <td align="middle" class="text-center">
                  <img [src]="addOn.image_1 | imagePath" class="accrs-img" />
                </td>
                <td>
                  <h6 class="bold text-capitalize m-0">{{ addOn.title }}</h6>
                  <p class="m-0" *ngIf="addOn.part_number">Part No : {{ addOn.part_number }}</p>
                  <p *ngIf="!addOn.inStock && addOn.total_quantity > 0">
                    <a [routerLink]="['/accessories-details', cat.slug, addOn.part_number, addOn.id]" (click)="modal.dismiss('Cross click')" class="availble-differ">Available in different warehouse</a>
                  </p>
                </td>
                <td>
                  <p *ngIf="is_hide_cost == null" class="mb-0"> {{ addOn?.discounted_price | currency: addOn?.vendor?.currency:'symbol' }} </p>
                  <p *ngIf="is_hide_cost != null" class="mb-0"> MSRP {{ addOn?.price | currency: addOn?.vendor?.currency:'symbol' }} </p>
                </td>
                <td>
                  <span class="in-stk" *ngIf="addOn.inStock">In Stock</span>
                  <span class="out-stk" *ngIf="!addOn.inStock">Out Of Stock</span>
                </td>
                <td>
                  <div class="custom-label new-quantity-box">
                        <div class="input-group custom-adder custom-adder-rw position-relative">
                          <input type="button" value="-" class="button-minus" 
                          (click)="updateQuantity(addOn, '-')">
                          <input type="number" step="1" [min]="minQuantity"
                             name="quantity" class="quantity-field" [(ngModel)]="addOnQty[addOn.id + '_' + addOn.inventory?.warehouse_id]">
                          <input type="button" value="+" class="button-plus"
                          (click)="updateQuantity(addOn, '+')">
                          <label class="f-light">Quantity</label>
                        </div>
                      </div>
                  <!-- <div class="input-group custom-adder custom-adder-rw position-relative">
                    <input type="button" value="-" class="button-minus" (click)="updateQuantity(addOn, '-')" />
                    
                    <input type="number" step="1" [min]="minQuantity" [(ngModel)]="addOnQty[addOn.id + '_' + addOn.inventory?.warehouse_id]" name="quantity" class="quantity-field" />
                    
                    <input type="button" value="+" class="button-plus" (click)="updateQuantity(addOn, '+')">
                    <label class="f-light">Quantity</label>
                  </div> -->
<!-- 
                  <input autocomplete="off" type="number" step="1" min="0" name="quantity" [max]="addOn.inventory?.quantity" class=" bd-color search-inputs-bold input-details mr-2"
                          [(ngModel)]="addOnQty[addOn.id + '_' + addOn.inventory?.warehouse_id]"
                          (ngModelChange)="addEditQty(addOn, $event)" /> -->

                          <!-- <input type="number"/> -->
                </td>
                <td>
                  <button type="button" class="button-accer"
                    [disabled]="addOnQty[addOn.id + '_' + addOn.inventory?.warehouse_id] === undefined || addOnQty[addOn.id + '_' + addOn.inventory?.warehouse_id] <= 0"
                    (click)="onAddToCart(addOn)">
                    <i class="fa fa-shopping-cart icon"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
